import React, { useState, useContext, useEffect } from "react";
import AuthContext from "../../Context/AuthContext";
import { Link, useNavigate } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import Breadcrumbs from "../../Navigation/Components/Breadcrumbs";
import Dropdown from "react-bootstrap/Dropdown";
import Button from "react-bootstrap/Button";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList, faLanguage } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import "./NewHobbyForm.css";

function NewHobbyForm() {
  const [title, setTitle] = useState("");
  const [title_english, setTitleEnglish] = useState("");
  const [english, setEnglish] = useState(false);

  const navigate = useNavigate();

  const { state } = useContext(AuthContext);

  const { t } = useTranslation();

  useEffect(() => {
    async function fetch() {
      if (state.language === "en") {
        setEnglish(true);
      } else {
        setEnglish(false);
      }
    }
    fetch();
  }, [state.language]);

  const activateEnglish = () => {
    setEnglish(true);
  };

  const handleSubmit = async () => {
    try {
      await axios({
        method: "post",
        url: `${process.env.REACT_APP_BACKEND_URL}/hobbies`,
        data: {
          title: title,
          title_english: title_english,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      navigate("/hobbies");
    } catch (error) {
      console.log(error.response.data);
    }
  };

  const handleTitleChange = (evt) => {
    setTitle(evt.target.value);
  };

  const handleTitleEnglishChange = (evt) => {
    setTitleEnglish(evt.target.value);
  };

  let breadcrumbs = [
    {
      title: state.language === "es" ? "Hobbies" : "Hobbies",
      path: "/hobbies",
    },
  ];

  return (
    <Container fluid>
      <Row>
        <Breadcrumbs data={breadcrumbs} />
      </Row>
      <Row>
        <Col lg={11} className="new-hobby-header">
          <h2>{t("Hobbies.Hobby.NewForm.Titulo")}</h2>
        </Col>
        <Col lg={1} className="new-scale-header mb-2">
          <Dropdown>
            <Dropdown.Toggle id="dropdown-basic">
              <FontAwesomeIcon icon={faList} />
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item onClick={activateEnglish}>
                <FontAwesomeIcon icon={faLanguage} /> English
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </Col>
      </Row>
      <Row>
        <Col className="new-hobby-form">
          <Form>
            <FloatingLabel label="Nombre del hobby" className="mb-3">
              <Form.Control
                type="text"
                placeholder="nombre del hobby"
                onChange={handleTitleChange}
              />
            </FloatingLabel>
            {english ? (
              <FloatingLabel label="Name of the hobby" className="mb-3">
                <Form.Control
                  type="text"
                  placeholder="Name of the hobby"
                  onChange={handleTitleEnglishChange}
                />
              </FloatingLabel>
            ) : (
              <></>
            )}
            <Button className="primary" onClick={handleSubmit}>
              {t("Hobbies.Hobby.NewForm.Guardar")}
            </Button>
            <Link to="/hobbies">
              <Button className="danger">
                {t("Hobbies.Hobby.NewForm.Cancelar")}
              </Button>
            </Link>
          </Form>
        </Col>
      </Row>
    </Container>
  );
}

export default NewHobbyForm;
